import { CommonGet, CommonPost } from '../../helpers/HttpClient';

export default {
  getGroupsForDropdown,
  GetSupplierForDropdown,
  GetBudgetCodeForDropdown,
  GetSKUCategoryForDropdown,
  GetSKUForDropdown,
  SaveSupplierSKUMapping,
  getAllGroups,
  GetSKUCategoryNamesByID,
  GetSKUNamesByCategoryID,
  GetSupplierForDropdownForName,
  getMappingDetailsForListing,
  GetExistingSupplierMappingDetails,
  getFactoriesByGroupID,
  getfactoriesForDropDown,
  getSuppliersForDropDownAuto,
  // getSuppliersForDropDown
}

async function getAllGroups() {
  let response = await CommonGet('/api/Factory/GetAllActiveGroups', null);
  let groupArray = []
  for (let item of Object.entries(response.data)) {
    groupArray[item[1]["groupID"]] = item[1]["groupName"]
  }
  return groupArray;
}

async function getGroupsForDropdown() {
  const response = await CommonGet('/api/Group/GetAllGroups', null)
  return response.data;
}

async function GetBudgetCodeForDropdown() {
  var budgetCodeArray = [];
  const response = await CommonGet('/api/BudgetCode/GetAllBudgetCodes', null)
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] === true) {
      budgetCodeArray[item[1]["budgetCodeID"]] = item[1]["budgetCodeName"]
    }
  }
  return budgetCodeArray;
}

async function GetSupplierForDropdown(groupID) {
  const response = await CommonGet('/api/AccountingSupplier/GetSuppliersByGroupIDAndFactoryID', 'groupID=' + groupID)
  return response.data;

}

async function GetSupplierForDropdownForName(groupID) {
  var supplierArray = [];
  const response = await CommonGet('/api/AccountingSupplier/GetSuppliersByGroupIDAndFactoryID', 'groupID=' + groupID)
  
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] === true) {
      supplierArray[item[1]["supplierID"]] = item[1]["supplierName"]
    }
  }
  return supplierArray;
}

async function GetSKUCategoryForDropdown(groupID) {
  var skuCategoryArray = [];
  const response = await CommonGet('/api/SKUMaster/GetSKUTCategories', null)
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] === true && item[1]["groupID"] == groupID) {
      skuCategoryArray[item[1]["skuCategoryID"]] = item[1]["skuCategoryName"]
    }
  }
  return skuCategoryArray;
}

async function GetSKUForDropdown(groupID, budgetcodeID, skuCategoryID) {
  var skuArray = [];
  const response = await CommonGet('/api/SKUMaster/GetSKUTypes', null)
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] === true && item[1]["groupID"] == groupID && item[1]["skuCategoryID"] == skuCategoryID && item[1]["budgetCodeID"] == budgetcodeID) {
      skuArray[item[1]["skuMasterID"]] = item[1]["skuMasterName"]
    }
  }
  return skuArray;
}

async function SaveSupplierSKUMapping(saveModel) {
  const response = await CommonPost('/api/SupplierSKUMapping/SaveSupplierSKUMappingData', null, saveModel)
  return response;
}

async function GetSKUCategoryNamesByID(budgetCodeID,groupID ,factoryID) {
  let response = await CommonGet('/api/SKUCategory/GetSKUCategoryNamesByEstateIDBudgetCodeIDANDFactoryID', 'budgetCodeID=' + budgetCodeID +'&groupID=' + groupID +'&factoryID=' + factoryID );
  let categoryArray = [];
  for (let item of Object.entries(response.data)) {
    categoryArray[item[1]["skuCategoryID"]] = item[1]["skuCategoryName"];
  }
  return categoryArray;
}

async function GetSKUNamesByCategoryID(skuCategoryID) {
  let response = await CommonGet('/api/WarehouseSKUMapping/GetSKUNamesByCategoryID', 'skuCategoryID=' + skuCategoryID);
  let skuArray = [];
  for (let item of Object.entries(response.data)) {
    skuArray[item[1]["skuMasterID"]] = item[1]["skuMasterName"];
  }
  return skuArray;
}

async function getMappingDetailsForListing(model) {
  const response = await CommonPost('/api/SupplierSKUMapping/GetMappingDetailsForListing', null, model);
  return response;
}

async function GetExistingSupplierMappingDetails(model) {
  let response = await CommonPost('/api/SupplierSKUMapping/GetExistingSupplierMappingDetails', null, model);
  return response;
}

// async function getSuppliersForDropDown(factoryID) {
//   var supplierArray = [];
//   const response = await CommonGet('/api/AccountingSuppliers/GetSuppliersForDropDown', "factoryID=" + parseInt(factoryID));
//   for (let item of Object.entries(response.data)) {
//     supplierArray[item[1]["supplierID"]] = { name: item[1]["supplierName"], code: item[1]["supplierCode"] }
//   }
//   return supplierArray;
// }

async function getFactoriesByGroupID(groupID) {
  var factoryArray = [];
  const response = await CommonGet('/api/Group/GetFactoryByGroupID', "groupID=" + parseInt(groupID));
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
  }
  return factoryArray;
}

async function getfactoriesForDropDown(groupID) {
  var factoryArray = [];
  const response = await CommonGet('/api/Group/GetFactoryByGroupID', 'groupID=' + groupID)
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
  }
  return factoryArray;
}

async function getSuppliersForDropDownAuto(factoryID) {
  const response = await CommonGet('/api/AccountingSuppliers/GetSuppliersForDropDown', "factoryID=" + parseInt(factoryID));
  return response.data;
}

// async function getSuppliersForDropDown(factoryID) {
//   var supplierArray = [];
//   const response = await CommonGet('/api/AccountingSuppliers/GetSuppliersForDropDown', "factoryID=" + parseInt(factoryID));
//   for (let item of Object.entries(response.data)) {
//     supplierArray[item[1]["supplierID"]] = { name: item[1]["supplierName"], code: item[1]["supplierCode"] }
//   }
//   return supplierArray;
// }